module.exports = __webpack_public_path__ + "static/media/archive.3246ffde.png";